
import { Fragment } from "react";
import { Check, X, Eye, EyeOff } from "react-feather";
import themeConfig from "../configs/themeConfig";
import Avatar from "../@core/components/avatar"
import toast from "react-hot-toast";
import moment from "moment/moment";
import { v4 as uuidv4 } from 'uuid';
import ability from '@configs/acl/ability'
import { AiFillInfoCircle, AiFillCheckCircle, AiFillCloseCircle } from "react-icons/ai";
import FileSaver from 'file-saver';
// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = (num) => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "")
// ** Checks if the passed date is today
const isToday = (date) => {
	const today = new Date()
	return (
		/* eslint-disable operator-linebreak */
		date.getDate() === today.getDate() &&
		date.getMonth() === today.getMonth() &&
		date.getFullYear() === today.getFullYear()
		/* eslint-enable */
	)
}

export function convertString(string) {
	const words = string.split('_');
	return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

}


export const getIconClass = (iconName, skin) => {
	// Determine the appropriate class based on the current skin mode
	return skin === 'dark' ? `dark-mode-icon ${iconName}` : `light-mode-icon ${iconName}`;
};
/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
	value,
	formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
	if (!value) return value
	return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value))
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
	const date = new Date(value)
	let formatting = { month: "short", day: "numeric" }

	if (toTimeForCurrentDay && isToday(date)) {
		formatting = { hour: "numeric", minute: "numeric" }
	}

	return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value))
}

export const formatOptionLabel = (props) => (
	<div className="d-flex flex-direction-column">
		<span>{props.label}</span>
		<span style={{ fontStyle: "italic", fontSize: "12px" }}>{props?.info ? `(${props?.info})` : ''}</span>
	</div>
);

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData")
export const getUserData = () => JSON.parse(localStorage.getItem("userData"))
export const getAbility = () => JSON.parse(localStorage.userData)?.ability
/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */

export const getdefaultLogoPath = (path) => {
	return themeConfig.app.apiUrl + "/storage/images/" + path
}

export const handlePermission = (permissionList, setPermissions, permissions, item, subject, action, event) => {
	let temp = []
	if (event.target.checked) {
		if (action === 'read') {
			temp.push({ action: action, subject: subject });
		} else if (action === 'manage') {
			temp.push({ action: 'manage', subject: subject }, { action: "read", subject: subject })
		}
		else if (action === 'readAll') {
			permissionList.map((item) => {
				temp.push({ action: 'read', subject: item.subject })
			})
		}
		else if (action === 'manageAll') {
			permissionList.map((item) => {
				item.list && item.list.map((li) => {
					if (li.action) {
						temp.push({ action: li.action, subject: item.subject })
					}
				})
			})
		}
		const combinedArray = [...temp, ...permissions];
		const uniqueArray = [...new Set(combinedArray.map(JSON.stringify))].map(JSON.parse);
		setPermissions(uniqueArray);
	} else {
		let remove = []
		if (action === 'read') {
			remove = permissions.filter(item => (item.action !== action || item.subject !== subject));
		} else if (action === 'manage') {
			remove = permissions.filter(item => (item.action !== action || item.subject !== subject) && !(item.action === 'read' && item.subject === subject));
		}
		setPermissions(remove)
	}
}



export const getHomeRouteForLoggedInUser = (userRole) => {
	if (userRole) return '/dashboard'
	return "/login"
}


export const getDynamicPermission = (permissions) => {
	let allPermission = getPermissionList()
	let tradeToolPermission = themeConfig[1].filter(item => allPermission.some(obj => obj.subject === item.subject))
	let dealershipPermission = permissions
	let TotalPermisison = dealershipPermission.filter(item => allPermission.some(obj => obj.subject === item.subject));
	return [...TotalPermisison, ...tradeToolPermission]
}



export const getPermissionList = () => {
	let ability = getAbility() ? JSON.parse(getAbility()) : ''
	let Permissions = ability.reduce((result, abilityItem) => {
		const existingSubject = result.find(item => item.subject === abilityItem.subject);
		if (existingSubject) {
			const existingAction = existingSubject.list.find(listItem => listItem.action === abilityItem.action);
			if (!existingAction) {
				existingSubject.list.push({ action: abilityItem.action, checkbox: 'false' });
			}
		} else {
			const newItem = {
				name: abilityItem.subject.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
				subject: abilityItem.subject,
				list: [
					{ action: abilityItem.action, checkbox: 'false' }
				]
			};
			result.push(newItem);
		}

		return result;
	}, []);

	Permissions.map((item) => {
		if (item.list[0].action === 'manage') {
			item.list.reverse();
		}
		if (item.list && item.list.length === 1) {
			// if (item.list[0].action === 'read') {
			item.list.push({ 'empty': true })
			// }
		}
	})
	return Permissions

}

export const getlogoPath = (logo) => {
	return themeConfig.app.apiUrl + "/storage/images/" + logo
}

export const customStyles = {
	multiValue: (provided) => ({
		...provided,
		color: 'white',
		backgroundColor: '#0b3365',
	}),
	multiValueLabel: (provided) => ({
		...provided,
		color: 'white',
	}),
	multiValueRemove: (provided) => ({
		...provided,
		color: 'white',
		':hover': {
			backgroundColor: '#0f57b1',
		},
	}),
	container: (provided) => ({
		...provided,
		color: 'black',
		width: '100%',
	}),
	menuPortal: (base) => ({
		...base,
		zIndex: 9999,
	}),
};


// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
	...theme,
	colors: {
		...theme.colors,
		primary25: "#7367f01a", // for option hover bg-color
		primary: "#7367f0", // for selected option bg-color
		neutral10: "#7367f0", // for tags bg-color
		neutral20: "#ededed", // for input border-color
		neutral30: "#ededed" // for input hover border-color
	}
})

export const ToastContainer = ({ title, message, type = 'success' }) => (
	<Fragment>
		<div className='toastify-header'>
			<div className='title-wrapper'>
				<Avatar size='sm' color={type} icon={type === 'success' ? <Check size={12} /> : <X size={12} />} />
				<h6 className='toast-title'>{title}!</h6>
			</div>
			{/* <small className='text-muted'>11 Min Ago</small> */}
		</div>
		<div className='toastify-body'>
			<span role='img' aria-label='toast-text'>
				{message}
			</span>
		</div>
	</Fragment>
)

export const ErrorToast = ({ t, message }) => (
	<div className='d-flex'>
		<div className='me-1'>
			<Avatar size='sm' color='danger' icon={<X size={12} />} />
		</div>
		<div className='d-flex flex-column'>
			<div className='d-flex justify-content-between'>
				<h6>Error</h6>
				<X size={12} className='cursor-pointer' onClick={() => toast.dismiss(t.id)} />
			</div>
			<span>{message}</span>
		</div>
	</div>
)

export const customFormatDate = (value, se = "start") => {
	const periods = { "start": ' 00:00:00', 'end': " 23:59:59" };
	return moment(value).format(themeConfig.mysqlFormats.date) + periods[se];
}

export const fullName = (param) => {
	return param?.first_name + ' ' + param?.last_name
}

// export const priceFormat = (x, symbol = '$') => {
// 	return symbol + x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
// };

export const priceFormat = (x, symbol = '$') => {
	const formattedPrice = Math.abs(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	if (x < 0) {
		return '-' + symbol + formattedPrice;
	}
	return symbol + formattedPrice;

};
export const dateTime = (value, type = 'both', givenDateFormat = '') => {
	var format = themeConfig?.formats[type] || themeConfig?.formats.both
	return moment(value, givenDateFormat).format(format);
}

export const defaultCheck = () => {

}

export const getApiPayload = (payload) => {
	if (!payload?.car_details && !Array.isArray(payload?.car_details)) return;
	// if (!payload?.car_details[0]?.api_payload) return;
	return payload?.car_details[0];
}

export const checkImage = path => {
	return new Promise(resolve => {
		const img = new Image();
		img.onload = () => resolve({ path, status: true });
		img.onerror = () => resolve({ path, status: false });

		img.src = path;
	});
}

export const utcToLocalTime = datetime => {
	return moment(moment.utc(datetime)).local().format('HH:mm A') === 'Invalid date' ? moment(moment.utc(moment().format('YYYY-MM-DD ') + datetime)).local().format('hh:mm A') : moment(moment.utc(datetime)).local().format('HH:mm A');
}

export const weekDays = () => {

	return {
		'1': {
			shortName: 'MN',
			longName: 'monday',
		},
		'2': {
			shortName: 'TU',
			longName: 'tuesday',
		},
		'3': {
			shortName: 'WD',
			longName: 'wednesday',
		},
		'4': {
			shortName: 'TH',
			longName: 'thursday',
		},
		'5': {
			shortName: 'FI',
			longName: 'friday',
		},
		'6': {
			shortName: 'SA',
			longName: 'saturday',
		},
		'7': {
			shortName: 'SU',
			longName: 'sunday',
		},
	};
}

export const ucfirst = (str) => {
	var splitStr = str.toLowerCase().split(' ');
	for (var i = 0; i < splitStr.length; i++) {
		splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
	}
	// Directly return the joined string
	return splitStr.join(' ');
}
export const formatUserRoleName = (roleName) => {
	return ucfirst(roleName.replaceAll('_', ' '))
}

export const getVisitorId = () => {
	return uuidv4().replace(/-/g, '')
}

export const convertDate = (date, format = 'YYYY-MM-DD') => {
	// return Array.isArray(date) ? date.map((item) => moment(item).format(format) ) : moment(date).format(format)
	return Array.isArray(date) /* && date.length > 1 */ ? date.map((item) => moment(item).format(format)) : date
}

export const isValidEmail = (email) => {
	return /\S+@\S+\.\S+/.test(email);
}
// export const capitalize = (string) => {
// 	return string.charAt(0).toUpperCase() + string.slice(1);
//   }
/* export const Api = axios.create({
	baseURL: themeConfig.app.apiUrl,
	timeout: 30000,
	timeoutErrorMessage: 'Request Timeout!'
});
Api.defaults.headers.common['timezone'] = Intl.DateTimeFormat().resolvedOptions()?.timeZone || 'UTC'; */


export const urlToObject = async (image) => {
	if (image.indexOf('data:image/') === -1) return;
	const response = await fetch(image);
	const blob = await response.blob();
	const ext = blob.type.split('/')[1]
	const file = new File([blob], 'image.' + ext, { type: blob.type });
	return file
}

export const onImageUpload = (e, setLogo) => {
	const files = e.target.files
	const reader = new FileReader();
	reader.onload = function () {
		setLogo(reader.result);
	}
	return reader.readAsDataURL(files[0])
}

// Utility function to get initials
export const getInitials = (str) => {
	const getLetters = str
		.split(' ')
		.map((n) => n[0])
		.join('');
	return getLetters;
}


export const handlePermissionsTool = (selectedTool, permissionList, toolList) => {
	if (selectedTool?.length > 0) {
		const newPermissions = selectedTool.flatMap(item => themeConfig[item.id]).filter(permission => !permissionList.some(existingPermission => existingPermission.subject === permission.subject));
		if (newPermissions.length > 0) {
			if (getUserData().user_role_id !== 1) {
				let allPermission = getPermissionList()
				let result = newPermissions.filter(item => allPermission.some(obj => obj.subject === item.subject))

				return [...permissionList, ...result];
			} else {
				return [...permissionList, ...newPermissions];
			}
		} else {
			let remove = selectedTool && toolList.filter(item => !selectedTool.some(obj => obj.id === item.id));
			if (remove) {
				const total = remove.flatMap(item => themeConfig[item.id]).filter(permission => permissionList.some(existingPermission => existingPermission.subject === permission.subject));
				const updatedPermissionList = permissionList.filter(existingPermission => !total.some(permission => permission.subject === existingPermission.subject));
				return [...updatedPermissionList];
			}
		}
	} else {
		let remove = selectedTool && toolList.filter(item => !selectedTool.some(obj => obj.id === item.id));
		if (remove) {
			const total = remove.flatMap(item => themeConfig[item.id]).filter(permission => permissionList.some(existingPermission => existingPermission.subject === permission.subject));
			const updatedPermissionList = permissionList.filter(existingPermission => !total.some(permission => permission.subject === existingPermission.subject));
			return [...updatedPermissionList];
		}
	}
};





export const downloadExampleCSV = (e) => {
	e.preventDefault()
	const csvData = [
		['first_name', 'last_name', 'email', 'cell_phone', 'office_phone', 'title', 'employee_number', 'password', 'biography', 'date_of_birth', 'employee_start_date'],
		['Jeff', 'Ryan', 'JeffRyan@email.com', '0123456789', '0123456789', 'Example CSV ', '1', '12345678', 'Jeff Ryan is a software engineer with 5 years of experience.', '2023-11-01', '2023-11-14'],
	];
	const csvContent = csvData.map((row) => row.join(',')).join('\n');
	const blob = new Blob([csvContent], { type: 'text/csv' });
	const url = window.URL.createObjectURL(blob);
	const link = document.createElement('a');
	link.href = url;
	link.download = 'Import Dealership User Sample.csv';
	link.click();
	window.URL.revokeObjectURL(url);
}

export const renderIcon = (showPassword) => {
	if (showPassword === false) {
		return <Eye size={14} />
	} else {
		return <EyeOff size={14} />
	}
}

export const randomColor = () => {
	const stateNum = Math.floor(Math.random() * 6),
		states = ['light-success', 'light-danger', 'light-warning', 'light-info', 'light-primary', 'light-secondary']
	return states[stateNum]
}


export const PriorityOptions = [
	{ label: "Normal", value: 0, borderColor: "#a9c2fb", bgColor: "#d7e2fd", icon: <AiFillInfoCircle size={18} color='#356bf6' />, color: "info" },
	{ label: "Low", value: 1, borderColor: "#b6dfd1", bgColor: "#cfeae1", icon: <AiFillCheckCircle size={18} color='#26976b' />, color: "success" },
	{ label: "Medium", value: 2, icon: <AiFillInfoCircle size={18} color='rgb(199 106 12)' />, borderColor: "#e3b581", bgColor: "#f4e2cd", color: "warning" },
	{ label: "High", value: 3, bgColor: "#f6d3d4", icon: <AiFillCloseCircle size={18} color='#cc2323' />, borderColor: "#e98e91", color: "danger" }
]

export const TeamsOptions = [
	{ label: "Team 1", value: 0, borderColor: "#a9c2fb", bgColor: "#d7e2fd", icon: <AiFillInfoCircle size={18} color='#356bf6' />, color: "info" },
	{ label: "Team 2", value: 1, borderColor: "#b6dfd1", bgColor: "#cfeae1", icon: <AiFillCheckCircle size={18} color='#26976b' />, color: "success" },
	{ label: "Team 3", value: 2, icon: <AiFillInfoCircle size={18} color='rgb(199 106 12)' />, borderColor: "#e3b581", bgColor: "#f4e2cd", color: "warning" },
]


export const calendarsColor = { Business: 'primary', Holiday: 'success', Personal: 'danger', Family: 'warning', ETC: 'info' }




export const extractDropdown = (arr, defaultValue) => {
	const defIndex = arr.findIndex(el => el.label === defaultValue);
	if (arr.length === 0) {
		return { items: [{ value: "", label: defaultValue }], ids: [] }
	}
	const tmpItems = [...arr]
	if (defIndex >= 0) {
		tmpItems.splice(tmpItems[defIndex], 1);
	}
	const tmpIds = []
	tmpItems.map(el => {
		tmpIds.push(el.value)
	})
	return { items: tmpItems, ids: tmpIds }
}

export const calculateDateDifference = (startDateString, endDateString) => {

	// Parse the input date strings
	startDateString = moment(startDateString).format('YYYY-MM-DD')
	endDateString = moment(endDateString).format('YYYY-MM-DD')
	const startDate = moment(startDateString);
	const endDate = moment(endDateString);

	// Calculate the difference in days
	const daysDifference = endDate.diff(startDate, 'days');

	let result = '';
	// Decide the appropriate unit based on the difference

	if (daysDifference < 7) {
		result = `${daysDifference} day${daysDifference > 1 ? 's' : ''}`;
	} else if (daysDifference < 30) {
		const weeks = Math.floor(daysDifference / 7);
		result = `${weeks} week${weeks > 1 ? 's' : ''}`;
	} else if (daysDifference < 365) {
		const months = Math.floor(daysDifference / 30);
		result = `${months} month${months > 1 ? 's' : ''}`;
	} else {
		const years = Math.floor(daysDifference / 365);
		result = `${years} year${years > 1 ? 's' : ''}`;
	}
	return result
}

export const autoGeneratedCSV = (data, url, columns) => {
    // If columns are provided, map the `name` fields to create the selected columns array
    const selectedColumns = columns ? columns.map(col => col.name) : Object.keys(data[0]);

    // Log selected columns to debug
    console.log("Selected Columns:", selectedColumns);

    const headers = selectedColumns;
    const csvRows = [];
    
    // Add the headers to the CSV (use the label for headers)
    csvRows.push(headers.join(','));

    // Add the data rows for the selected columns
    data.forEach((item, index) => {
        const values = headers.map((header) => {
            let value = item[header];

            // If value is undefined or null, use an empty string
            if (value === undefined || value === null) {
                value = '';
            }

            // Handle commas and quotes in values
            if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
                value = `"${value.replace(/"/g, '""')}"`; // Escape quotes
            }
            return value;
        });

        // Log row data for debugging
        console.log(`Row ${index + 1}:`, values);

        // Only push the row if it has any valid data
        csvRows.push(values.join(','));
    });

    // Join the rows with newline characters
    const csvData = csvRows.join('\n');

    // Check if CSV data is generated properly
    console.log("CSV Data:", csvData); // Debug log

    // Create a blob with CSV data
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
    return FileSaver.saveAs(blob, `${url}.csv`);
}

export const Rating = (rating) => {
    if (rating === 1 || rating <= 3) {
      return 'Rough';
    } else if (rating === 4 || rating <= 6) {
      return 'Average';
    } else if (rating === 7 || rating <= 10) {
      return 'Clean';
    } else {
      return 'N/A';
   }
}  

